<template>
    <div class="home-step" style="position:relative">
        <div class="button-cookbook-wrapper">
            <div class="button-cookbook">
                <img @click="nextStep()" class="pastille-airfryer-cookbook" src="/images/fr_multigift_carousel/pastille-airfryer-cookbook-m.png" alt="airfryer cookbook">
                <b-button class="button is-primary next-button" @click="nextStep()">Demander votre e-book</b-button>
            </div>
        </div>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>

    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";

export default {
    mixins: [mixin],
}
</script>
